"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4610],{

/***/ "./src/components/Landing/RankingList.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("./node_modules/@chakra-ui/tabs/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("./node_modules/@chakra-ui/table/dist/index.esm.js");
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next-i18next/dist/esm/index.js");
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("./node_modules/react-icons/bi/index.esm.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var _Rank_RankButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/components/Rank/RankButton.tsx");
/* harmony import */ var _Rank_RankTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/components/Rank/RankTable.tsx");
/* harmony import */ var _Rank_FoundersRankTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/components/Rank/FoundersRankTable.tsx");
/* harmony import */ var _Rank_InvalidRankCardItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/components/Rank/InvalidRankCardItem.tsx");
/* harmony import */ var _Rank_RankCardItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/components/Rank/RankCardItem.tsx");
/* harmony import */ var _Rank_FounderRankCardItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/components/Rank/FounderRankCardItem.tsx");
/* harmony import */ var _Elements__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/components/Elements/index.ts");
/* harmony import */ var _pages_rank_category___WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/pages/rank/[[...category]].tsx");
/* harmony import */ var _data_RankingListData__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./src/data/RankingListData.ts");
/* harmony import */ var _utils_DataTransform_getKeyByValue__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("./src/utils/DataTransform/getKeyByValue.ts");
















const RankingList = (param)=>{
    let { rankings , listingLimit  } = param;
    const { TokensListing , aiTokensListing , NFTsListing , stableCoinsListing , foundersListing  } = rankings;
    const [tokenItems, setTokenItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [aiTokenItems, setAiTokenItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [stableCoinItems, setStableCoinItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [nftItems, setNftItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [founderItems, setFounderItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [sortOrder, setOrder] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("descending");
    const [selectedRanking, setSelectedRanking] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("cryptocurrencies");
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)([
        "rank",
        "common"
    ]);
    if (TokensListing && aiTokensListing && NFTsListing && stableCoinsListing && foundersListing && (!(tokenItems === null || tokenItems === void 0 ? void 0 : tokenItems.length) || !(nftItems === null || nftItems === void 0 ? void 0 : nftItems.length) || !(aiTokenItems === null || aiTokenItems === void 0 ? void 0 : aiTokenItems.length) || !(stableCoinItems === null || stableCoinItems === void 0 ? void 0 : stableCoinItems.length) || !(founderItems === null || founderItems === void 0 ? void 0 : founderItems.length))) {
        setTokenItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)("descending", TokensListing));
        setAiTokenItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)("descending", aiTokensListing));
        setNftItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)("descending", NFTsListing));
        setStableCoinItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)("descending", stableCoinsListing));
        setFounderItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)("descending", foundersListing));
    }
    const onClickMap = {
        "Market Cap": function() {
            if (tokenItems && nftItems && aiTokenItems && stableCoinItems && founderItems) {
                const newSortOrder = sortOrder === "ascending" ? "descending" : "ascending";
                setOrder(newSortOrder);
                setTokenItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)(newSortOrder, TokensListing));
                setAiTokenItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)(newSortOrder, aiTokensListing));
                setStableCoinItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)(newSortOrder, stableCoinsListing));
                setNftItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)(newSortOrder, NFTsListing));
                setFounderItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortByMarketCap)(newSortOrder, foundersListing));
            }
        },
        "24h Change": function() {
            if (tokenItems && nftItems && aiTokenItems && stableCoinItems && founderItems) {
                const newSortOrder = sortOrder === "ascending" ? "descending" : "ascending";
                setOrder(newSortOrder);
                setTokenItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortBy24hChange)(newSortOrder, TokensListing));
                setAiTokenItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortBy24hChange)(newSortOrder, aiTokensListing));
                setStableCoinItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortBy24hChange)(newSortOrder, stableCoinsListing));
                setNftItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortBy24hChange)(newSortOrder, NFTsListing));
                setFounderItems((0,_pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.sortBy24hChange)(newSortOrder, foundersListing));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .xu, {
        px: {
            base: 3,
            md: 8
        },
        pb: {
            base: 16,
            md: 20,
            lg: 24
        },
        pt: {
            lg: 4
        },
        textAlign: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Heading */ .X6, {
                textAlign: "center",
                mb: 4,
                fontWeight: "600",
                fontSize: {
                    base: "3xl",
                    lg: 46
                },
                children: "".concat(t("rankingListHeading"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .xv, {
                color: "homeDescriptionColor",
                fontSize: {
                    base: "lg",
                    lg: "20px"
                },
                mx: "auto",
                mb: 9,
                px: 4,
                maxW: "768",
                children: "".concat(t("rankingListDescription"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .xu, {
                maxW: "1208px",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Tabs */ .mQ, {
                        mt: 10,
                        pl: 0,
                        overflowX: "auto",
                        onChange: (index)=>{
                            setSelectedRanking((0,_utils_DataTransform_getKeyByValue__WEBPACK_IMPORTED_MODULE_14__/* .getKeyByValue */ .V)(_data_RankingListData__WEBPACK_IMPORTED_MODULE_11__/* .CATEGORIES_WITH_INDEX */ .kq, index));
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .kC, {
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .TabList */ .td, {
                                    border: "none",
                                    display: "flex",
                                    gap: {
                                        base: "0",
                                        md: "4"
                                    },
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            label: t("rankingListButtonCryptocurrencies"),
                                            icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_15__/* .RiCoinsFill */ .SSK,
                                            fontSize: {
                                                lg: "md"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            label: t("rankingListButtonStablecoins"),
                                            icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_15__/* .RiCoinFill */ .KMb,
                                            fontSize: {
                                                lg: "md"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            label: t("rankingListButtonAITokens"),
                                            icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_15__/* .RiRobotFill */ .yV4,
                                            fontSize: {
                                                lg: "md"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            label: t("rankingListButtonFounders"),
                                            icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_15__/* .RiUserFill */ .dgb,
                                            fontSize: {
                                                lg: "md"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            label: t("rankingListButtonNfts"),
                                            icon: react_icons_bi__WEBPACK_IMPORTED_MODULE_16__/* .BiImage */ .ntj,
                                            fontSize: {
                                                lg: "md"
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .TabPanels */ .nP, {
                                mt: {
                                    base: 8,
                                    md: "10"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .TabPanel */ .x4, {
                                        px: {
                                            base: 0,
                                            md: "initial"
                                        },
                                        py: {
                                            base: 0,
                                            md: "initial"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Rank_RankTable__WEBPACK_IMPORTED_MODULE_4__/* .RankTable */ .v, {
                                            hasPagination: false,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankTable__WEBPACK_IMPORTED_MODULE_4__/* .RankTableHead */ ._, {
                                                    onClickMap: onClickMap
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Tbody */ .p3, {
                                                    children: tokenItems.map((token, index)=>token ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankCardItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                            listingLimit: listingLimit,
                                                            offset: 0,
                                                            order: sortOrder,
                                                            index: index,
                                                            item: token
                                                        }, index + token.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_InvalidRankCardItem__WEBPACK_IMPORTED_MODULE_6__/* .InvalidRankCardItem */ .D, {
                                                            index: index
                                                        }, index))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .TabPanel */ .x4, {
                                        px: {
                                            base: 2,
                                            md: "initial"
                                        },
                                        py: {
                                            base: 0,
                                            md: "initial"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Rank_RankTable__WEBPACK_IMPORTED_MODULE_4__/* .RankTable */ .v, {
                                            hasPagination: false,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankTable__WEBPACK_IMPORTED_MODULE_4__/* .RankTableHead */ ._, {
                                                    onClickMap: onClickMap
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Tbody */ .p3, {
                                                    children: stableCoinItems.map((token, index)=>token ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankCardItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                            listingLimit: listingLimit,
                                                            offset: 0,
                                                            order: sortOrder,
                                                            index: index,
                                                            item: token
                                                        }, index + token.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_InvalidRankCardItem__WEBPACK_IMPORTED_MODULE_6__/* .InvalidRankCardItem */ .D, {
                                                            index: index
                                                        }, index))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .TabPanel */ .x4, {
                                        px: {
                                            base: 2,
                                            md: "initial"
                                        },
                                        py: {
                                            base: 0,
                                            md: "initial"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Rank_RankTable__WEBPACK_IMPORTED_MODULE_4__/* .RankTable */ .v, {
                                            hasPagination: false,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankTable__WEBPACK_IMPORTED_MODULE_4__/* .RankTableHead */ ._, {
                                                    onClickMap: onClickMap
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Tbody */ .p3, {
                                                    children: aiTokenItems.map((token, index)=>token ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankCardItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                            listingLimit: listingLimit,
                                                            offset: 0,
                                                            order: sortOrder,
                                                            index: index,
                                                            item: token
                                                        }, index + token.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_InvalidRankCardItem__WEBPACK_IMPORTED_MODULE_6__/* .InvalidRankCardItem */ .D, {
                                                            index: index
                                                        }, index))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .TabPanel */ .x4, {
                                        px: {
                                            base: 2,
                                            md: "initial"
                                        },
                                        py: {
                                            base: 0,
                                            md: "initial"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Rank_FoundersRankTable__WEBPACK_IMPORTED_MODULE_5__/* .FoundersRankTable */ .y, {
                                            hasPagination: false,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_FoundersRankTable__WEBPACK_IMPORTED_MODULE_5__/* .FoundersRankTableHead */ .C, {
                                                    onClickMap: onClickMap
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Tbody */ .p3, {
                                                    children: founderItems.map((token, index)=>token ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_FounderRankCardItem__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                            listingLimit: listingLimit,
                                                            offset: 0,
                                                            order: sortOrder,
                                                            index: index,
                                                            item: token
                                                        }, index + token.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_InvalidRankCardItem__WEBPACK_IMPORTED_MODULE_6__/* .InvalidRankCardItem */ .D, {
                                                            index: index
                                                        }, index))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .TabPanel */ .x4, {
                                        px: {
                                            base: 2,
                                            md: "initial"
                                        },
                                        py: {
                                            base: 0,
                                            md: "initial"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Rank_RankTable__WEBPACK_IMPORTED_MODULE_4__/* .RankTable */ .v, {
                                            hasPagination: false,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankTable__WEBPACK_IMPORTED_MODULE_4__/* .RankTableHead */ ._, {
                                                    onClickMap: onClickMap
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Tbody */ .p3, {
                                                    children: nftItems.map((nft, index)=>nft ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_RankCardItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                            listingLimit: _pages_rank_category___WEBPACK_IMPORTED_MODULE_10__.LISTING_LIMIT,
                                                            offset: 0,
                                                            order: sortOrder,
                                                            index: index,
                                                            item: nft
                                                        }, index + nft.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Rank_InvalidRankCardItem__WEBPACK_IMPORTED_MODULE_6__/* .InvalidRankCardItem */ .D, {
                                                            index: index
                                                        }, index))
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .kC, {
                        justifyContent: "center",
                        mt: "10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Elements__WEBPACK_IMPORTED_MODULE_9__/* .LinkButton */ .Qj, {
                            href: "/rank/".concat(selectedRanking),
                            h: "50px",
                            w: {
                                base: 32,
                                lg: 40
                            },
                            variant: "outline",
                            bgColor: "btnBgColor",
                            prefetch: false,
                            children: t("rankingListViewMore")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RankingList);


/***/ })

}]);